import styled from 'styled-components';
import Typography from '../typography/Typography';
export const QrModalContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.media.laptop `
   max-width: 50rem;
  `};
`;
export const QrContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 3.3rem 17rem;
`;
export const QrCodeWrapper = styled.div `
  padding: 0.9rem;
  border-radius: ${({ theme }) => theme.borderRadius.high};
  background: linear-gradient(145.67deg, #3067db 20.29%, #52a2ff 104.35%);
`;
export const ScanCodeText = styled(Typography) `
  padding: 0 7.3rem 3.6rem 7.3rem;
  text-align: center;
`;
export const QrWrapper = styled.div `
  padding: 0.9rem;
  background-color: ${({ theme }) => theme.colors.background.light};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
//# sourceMappingURL=styles.js.map